exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".white{color:#fff}.mainColorText{color:#00558b}.mainColorBackground{background-color:#00558b}.greyText{color:grey}.listingTitle{background-color:#e4e7eb;border-top:solid #00558b;border-radius:5px;font-size:20px}.listingBody{background-color:#f5f7fa;border-top:.5px solid #d3d3d3;border-radius:5px;font-size:13px}.b-tooltip.bottom .tooltip-inner{max-width:60%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-68b761fe","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/component/ocean-insights/affectedSubscriptionCont.vue
// module id = 1668
// module chunks = 0